import { usePost, useAuth } from "@onefront/react-sdk";
import { generateHeaders } from "../../../utils/generate-headers";
import { IntermediaryData } from "../../../@types/dtos/intermediaries/IntermediaryData";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data: IntermediaryData;
}

interface IusePostIntermediaryData {
    (tenantItemId?: string, params?: any | object, lazy?: boolean): {
        data?: null;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePostIntermediaryData: IusePostIntermediaryData = (tenantItemId, params = {}, lazy = true) => {
    return usePost(
        `rnd:core:intermediary-registry-write:api://v1/${tenantItemId}/intermediary`,
        {},
        {
            params: {
                ...params
            },
            headers: generateHeaders(useAuth(), tenantItemId, tenantItemId),
            lazy
        }
    );
};
